export class UrlUtils {
  private constructor() {}
  public static getSearchStringFromMap(data: Record<string, string | number | boolean | null | undefined>): string {
    const parts: Array<string> = [];
    for (const [key, value] of Object.entries(data)) {
      if (value == null || value === false) {
        continue;
      }
      if (value === true) {
        parts.push(`${encodeURIComponent(key)}`);
      } else {
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }
    }
    return `?${parts.join('&')}`;
  }
}